import { adminHttpClient } from '../commons/adminHttpClient'
import { ExpenseStatus } from '../../domain/expenses/expenseStatus'
import { ExpenseTypeEligibility } from '../../domain/expenses/expenseTypeEligibility'
import { NamedItem } from '../../domain/common/namedItem'

export interface ExpenseForSaveResponse {
  expenseId?: string
  expenseFor?: string
  companyName: string
  messageToEmployee?: string
  familyMemberId?: string
  expenseType: ForSaveExpenseTypeResponse
  status: ExpenseStatus
  requestedAmount: number
  purchasedDate: string
  minPurchasedDate: string
  maxPurchasedDate: string
  serviceProvider: string
  description?: string
  expenseTypeEligibility: ExpenseTypeEligibility
  attachments: AttachmentResponse[]
  useMecAttestation: boolean
  mecCoverageProvider: NamedItem
  requiresAttestationConfirmationToSubmitExpense: boolean
}

type AttachmentResponse = {
  attachmentId: string
  fileNameUrl: string
  title: string
  reuseInOtherExpenses: boolean
}

type ForSaveExpenseTypeResponse = {
  id: string
  name: string
  eligibility: ExpenseTypeEligibility
}

export const getExpenseForSave = (
  planPeriodId: string,
  expenseTypeId: number,
  expenseId?: string,
): Promise<ExpenseForSaveResponse> => {
  return adminHttpClient.get(`/Expenses/ForSave/${planPeriodId}/${expenseTypeId}/${expenseId ?? ''}`)
}
